/* eslint-disable @typescript-eslint/no-unsafe-return */
/* eslint-disable @typescript-eslint/no-unsafe-member-access */
/* eslint-disable @typescript-eslint/no-unsafe-assignment */
import React from "react"
import {
  Button as MUIButton,
  ButtonProps as MUIButtonProps,
} from "@mui/material"
import { UnstyledButton, UnstyledButtonProps } from "@mantine/core"
import cx from "classnames"
import withMappedProps from "hoc-lib/propsMapping"
import styles from "./Button.mantine.module.scss"

export const MantineButton = UnstyledButton

export const muiToMantine = (
  props: MUIButtonProps,
): Partial<UnstyledButtonProps> => {
  const anyProps = props as any
  const variantClassName = props.variant
    ? styles[`button-variant-${props.variant}`]
    : undefined
  return {
    ...anyProps,
    unstyled: true,
    className: cx(
      props.className,
      "mantine-context",
      styles["button-root"],
      variantClassName,
      {
        [styles[`button-size-${props.size ?? "medium"}`]]: props.size,
        [styles["button-elevation"]]: !props.disableElevation,
        [styles["button-fullWidth"]]: props.fullWidth,
        [styles[`button-variant-containedSecondary`]]:
          props.variant === "contained" && props.color === "secondary",
      },
    ),
    pos: anyProps?.position,
  }
}

// eslint-disable-next-line @typescript-eslint/ban-ts-comment
// @ts-ignore
export const MUIMappedButton = withMappedProps(MantineButton, muiToMantine)

export default MantineButton
